import PropTypes from "prop-types";

import Title from "components/atoms/Title";

/** ========== */

const Component = ({ title, subTitle, data, children, ...props }) => {
  return (
    <div {...props}>
      <div className="container">
        <div className="row gap-y-6 lg:justify-end lg:gap-y-10">
          <div className="col-12 lg:col-4">
            {children ? (
              children
            ) : (
              <Title as="h2" className="text-center font-semibold lg:text-left">
                <span className="block text-bbc-40px text-bbc-brand-800">
                  {title}
                </span>
                <span
                  className={`mt-4 block text-2xl  leading-9 ${
                    subTitle && subTitle === "in 4 easy steps"
                      ? "text-bbc-brand-600"
                      : "text-bbc-brand-800"
                  }`}
                >
                  {subTitle}
                </span>
              </Title>
            )}
          </div>
          {data?.length > 0 &&
            data.map((item, index) => (
              <div className={"col-12 lg:col-4"} key={index}>
                <div>
                  <div
                    className="mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500"
                    style={{
                      width: "58px",
                      height: "58px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {index + 1}
                  </div>
                  {item?.title && (
                    <Title
                      as="h3"
                      className="mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold"
                    >
                      {item.title}
                    </Title>
                  )}
                  <p
                    className="leading-bbc-26 text-bbc-gray"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  ></p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.array,
};

Component.defaultProps = {
  data: [],
};

/** ========== */
